import { render, staticRenderFns } from "./OverallSituationLayout.vue?vue&type=template&id=727afa38&scoped=true"
import script from "./OverallSituationLayout.vue?vue&type=script&lang=js"
export * from "./OverallSituationLayout.vue?vue&type=script&lang=js"
import style0 from "./OverallSituationLayout.vue?vue&type=style&index=0&id=727afa38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727afa38",
  null
  
)

export default component.exports